"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Options = _interopRequireDefault(require("./Options.style"));

var _remindList = _interopRequireDefault(require(".././remindList.js"));

var _repeatList = _interopRequireDefault(require(".././repeatList.js"));

var _timezone = _interopRequireDefault(require(".././timezone.js"));

var _ToggleSwitch = _interopRequireDefault(require("../../ToggleSwitch/ToggleSwitch"));

var _Label = _interopRequireDefault(require("../../Label"));

var _Divider = _interopRequireDefault(require("../../Divider"));

var _Select = _interopRequireDefault(require("../../Select"));

var _MenuItem = _interopRequireDefault(require("../../Menu/MenuItem"));

var _dec, _class;

let Options = (_dec = (0, _reactJss.default)(_Options.default), _dec(_class = class Options extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleSetOption = this.handleSetOption.bind(this);
  }

  handleSetOption(data) {
    const {
      onChange
    } = this.props;
    onChange(data);
  }

  hasKey(value) {
    const {
      options
    } = this.props;
    return Object.prototype.hasOwnProperty.call(options, value);
  }

  renderRepeatOption() {
    const {
      size,
      repeatValue,
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.footerRow)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.selectLabel),
      fontSize: size,
      value: "Repeat"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.selectContainer)
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      id: "repeatValue",
      className: (0, _clsx.default)(classes.select),
      value: repeatValue,
      onChange: this.handleSetOption
    }, _repeatList.default.map((item, index) => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: index,
      label: item.label,
      value: index.toString(),
      activeItem: repeatValue
    })))));
  }

  renderToggle(labelValue, id) {
    const {
      size,
      classes,
      options
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.footerRow)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.toggleLabel),
      fontSize: size,
      value: labelValue
    }), /*#__PURE__*/_react.default.createElement(_ToggleSwitch.default, {
      id: id,
      value: options[id],
      onChange: this.handleSetOption
    }));
  }

  renderSelect(labelValue, id, selectItems) {
    const {
      size,
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.footerRow)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.selectLabel),
      fontSize: size,
      value: labelValue
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.selectContainer)
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      id: id,
      className: (0, _clsx.default)(classes.select),
      value: this.props[id],
      onChange: this.handleSetOption
    }, selectItems.map((item, index) => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: index,
      label: item.label,
      value: index.toString(),
      activeItem: this.props[id]
    })))));
  }

  renderTimeZone() {
    const {
      size,
      timeZoneOffset,
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.footerRow)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.selectLabel),
      fontSize: size,
      value: "Timezone"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.selectContainer)
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      id: "timeZoneOffset",
      className: (0, _clsx.default)(classes.select),
      value: timeZoneOffset.toString(),
      onChange: this.handleSetOption
    }, _timezone.default.map((t, index) => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: index,
      label: t.label,
      value: t.value.toString(),
      activeItem: timeZoneOffset.toString()
    })))));
  }

  render() {
    const {
      className,
      classes,
      size,
      timeZone,
      remind,
      repeat,
      options
    } = this.props;
    const displayTimeToggle = this.hasKey('time');
    const displayRangeToggle = this.hasKey('dateRange');
    const displayInviteToggle = this.hasKey('sendInvite');
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(className, classes.footer, classes[size])
    }, remind || repeat || timeZone ? /*#__PURE__*/_react.default.createElement(_Divider.default, {
      className: (0, _clsx.default)(classes.footerDivider)
    }) : null, timeZone ? this.renderTimeZone() : null, remind ? this.renderSelect('Remind', 'remindValue', _remindList.default) : null, repeat ? this.renderSelect('Repeat', 'repeatValue', _repeatList.default) : null, Object.keys(options).length !== 0 ? /*#__PURE__*/_react.default.createElement(_Divider.default, {
      className: (0, _clsx.default)(classes.divider)
    }) : null, displayTimeToggle ? this.renderToggle('Include time', 'time') : null, displayRangeToggle ? this.renderToggle('End date', 'dateRange') : null, displayInviteToggle ? this.renderToggle('Calendar invite', 'sendInvite') : null);
  }

}) || _class);
Options.defaultProps = {
  size: 'medium',
  timeZone: false,
  remind: false,
  repeat: false,
  displayTime: false,
  options: {},
  onChange: () => {}
};
var _default = Options;
exports.default = _default;